export default function Hero() {
  return (
    <section id="home">
      <div className="hero-grid-bg" />
      <div className="hero-glow" />
      <div className="hero-glow" />

      <div className="hero-content">
        <div className="hero-badge"><span>Proudly South African · Est. 2015</span></div>
        <h1 className="hero-title">
          Precision.<br />
          <span className="accent">Engineering.</span><br />
          Excellence.
        </h1>
        <p className="hero-sub">
          FM Maepa (Pty) Ltd Engineering delivers integrated, high-impact solutions across mining,
          civil, and industrial sectors — with over a decade of experience from concept to completion.
        </p>
        <div className="hero-actions">
          <a href="#projects" className="btn-primary">Our Projects</a>
          <a href="#about" className="btn-outline">Learn More</a>
        </div>
      </div>

      <div className="hero-stats">
        <div><div className="stat-num">10+</div><div className="stat-lbl">Years Experience</div></div>
        <div><div className="stat-num">100%</div><div className="stat-lbl">Commitment</div></div>
        <div><div className="stat-num">3</div><div className="stat-lbl">Core Sectors</div></div>
      </div>

      <div className="scroll-hint">
        <div className="scroll-line" />
        <span>Scroll</span>
      </div>
    </section>
  );
}
